import {
  CheckCircleOutlined,
  ClockCircleOutlined,
  CloseCircleOutlined,
} from '@ant-design/icons'
import React, { type ReactNode } from 'react'

import {
  INVITATION_STATUS_FILTER_ALL,
  type InvitationStatusFilterValue,
} from '../constants'
import { RecruitingInvitationStatusEnum } from '../schema/recruiting.schema'

export type InvitationStatusFilterOption = {
  value: InvitationStatusFilterValue
  label: string
  icon?: ReactNode
}

const API_STATUS_VALUES = new Set<string>([
  RecruitingInvitationStatusEnum.Active,
  RecruitingInvitationStatusEnum.Expired,
  RecruitingInvitationStatusEnum.Cancelled,
])

/** Maps URL `status` to the tag selection (defaults to All). */
export function getInvitationStatusFilterSelection(
  statusParam: string | string[] | undefined
): InvitationStatusFilterValue {
  const raw = Array.isArray(statusParam) ? statusParam[0] : statusParam
  if (!raw || raw === INVITATION_STATUS_FILTER_ALL) {
    return INVITATION_STATUS_FILTER_ALL
  }
  if (API_STATUS_VALUES.has(raw)) {
    return raw as RecruitingInvitationStatusEnum
  }
  return INVITATION_STATUS_FILTER_ALL
}

export const INVITATION_STATUS_FILTER_OPTIONS: InvitationStatusFilterOption[] =
  [
    { value: INVITATION_STATUS_FILTER_ALL, label: 'All' },
    {
      value: RecruitingInvitationStatusEnum.Active,
      label: 'Active',
      icon: <CheckCircleOutlined aria-hidden />,
    },
    {
      value: RecruitingInvitationStatusEnum.Expired,
      label: 'Expired',
      icon: <ClockCircleOutlined aria-hidden />,
    },
    {
      value: RecruitingInvitationStatusEnum.Cancelled,
      label: 'Cancelled',
      icon: <CloseCircleOutlined aria-hidden />,
    },
  ]
